'use es6';

import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["currencyCode", "currencyStyle"];
import { Component } from 'react';
import PropTypes from 'prop-types';
import { currencyStyles, currencyFormatters } from '../internal/utils/CurrencyLabelFormatters';
import { I18nHMRContext } from '../internal/i18n-internal';
import { jsx as _jsx } from "react/jsx-runtime";
export default class FormattedCurrencyLabel extends Component {
  render() {
    const _this$props = this.props,
      {
        currencyCode,
        currencyStyle
      } = _this$props,
      passThroughProps = _objectWithoutPropertiesLoose(_this$props, _excluded);
    return /*#__PURE__*/_jsx("span", Object.assign({}, passThroughProps, {
      children: currencyFormatters[currencyStyle](currencyCode)
    }));
  }
}
FormattedCurrencyLabel.displayName = 'FormattedCurrencyLabel';
FormattedCurrencyLabel.contextType = I18nHMRContext;
FormattedCurrencyLabel.propTypes = {
  currencyCode: PropTypes.string.isRequired,
  currencyStyle: PropTypes.oneOf(Object.keys(currencyFormatters))
};
FormattedCurrencyLabel.defaultProps = {
  currencyStyle: currencyStyles.short
};